import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/index.vue'
Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    routes: [
        //首页
        {
            path: '/',
            name: 'index',
            component: () => import("@/views/jump"),
        },
        //english
        {
            path: '/router=im/chat_page',
            component: Layout,
            children: [{
                path: '/',
                component: resolve => require(['@/views/customerservice'], resolve),
                children: [{
                        path: '',
                        redirect: 'chat',
                    },
                    {
                        path: 'chat',
                        name: 'chat',
                        component: resolve => require(['@/views/customerservice/chatRoom'],
                            resolve),
                        meta: {
                            title: '会话窗口',
                            sidebarType: 1
                        }
                    },
                    {
                        path: 'friendslist',
                        name: 'friendslist',
                        component: resolve => require(['@/views/customerservice/friendsList'],
                            resolve),
                        meta: {
                            title: '好友列表',
                            sidebarType: 1
                        }
                    },


                    //朋友圈
                    {
                        path: 'friendCircle',
                        name: 'friendCircle',
                        component: resolve => require(['@/views/wechatMoments/friendCircle'],
                            resolve),
                        meta: {
                            title: '个人查看朋友圈',
                            sidebarType: 1
                        }
                    }
                ]
            }]
        },
        //运营
        {
            path: '/router=im/operation',
            component: Layout,
            children: [{
                    path: '/',
                    component: resolve => require(['@/views/wechatMoments/operateManage'], resolve),
                    children: [{
                            path: '/',
                            component: resolve => require(['@/views/wechatMoments/operateManage'],
                                resolve),
                            beforeEnter: (to, from, next) => {
                                console.log(JSON.parse(localStorage.getItem('authPrivileges')))
                                console.log(to, 'to')
                                let listData = []
                                let authPrivileges = JSON.parse(localStorage.getItem(
                                    'authPrivileges'))
                                for (let i = 0; i < authPrivileges.length; i++) {
                                    if (authPrivileges[i].nm == "IM") {
                                        let imlist = authPrivileges[i].list;
                                        for (let jj = 0; jj < imlist.length; jj++) {
                                            if (imlist[jj].pc == "wx_im_operations_management" &&
                                                imlist[jj] != null) {
                                                let klist = imlist[jj].list
                                                for (let k = 0; k < klist.length; k++) {
                                                    if (klist[k].pc ==
                                                        "wx_im_operation_send_friends_circle") {
                                                        listData.push({
                                                            title: '发朋友圈',
                                                            url: '/router=im/operation/operation_send_friends_circle',
                                                            class: 'chatbar'
                                                        })
                                                    }
                                                    if (klist[k].pc ==
                                                        "wx_im_mass_texting_task") {
                                                        listData.push({
                                                            title: '群发任务',
                                                            url: '/router=im/operation/mass_texting_task',
                                                            class: 'friendbar'
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                // if(this.listData.length == 1){
                                //     this.$router.push({path:this.listData[0].url})
                                // }
                                // next('/router=im/operation/operation_send_friends_circle');
                                next(listData[0].url)
                            }
                        },
                        //发朋友圈
                        {
                            path: 'operation_send_friends_circle',
                            name: 'sendWechat',
                            component: resolve => require([
                                '@/views/wechatMoments/operateManage/sendWechat'
                            ], resolve),
                            meta: {
                                title: '发朋友圈',
                                sidebarType: 1
                            },
                        },
                        //群发消息
                        {
                            path: 'mass_texting_task',
                            name: 'groupSend',
                            component: resolve => require([
                                '@/views/wechatMoments/operateManage/groupSend'
                            ], resolve),
                            meta: {
                                title: '群发任务',
                                sidebarType: 1
                            },
                        },
                    ]
                }

            ]
        },
        //我的任务
        {
            path: '/router=im/individual',
            component: Layout,
            children: [{
                    path: '/',
                    component: resolve => require(['@/views/wechatMoments/groupSend'], resolve),
                    children: [{
                            path: '/',
                            component: resolve => require(['@/views/wechatMoments/groupSend'],
                                resolve),
                            beforeEnter: (to, from, next) => {
                                console.log(JSON.parse(localStorage.getItem('authPrivileges')))
                                console.log(to, 'to')
                                let listData = []
                                let authPrivileges = JSON.parse(localStorage.getItem(
                                    'authPrivileges'))
                                for (let i = 0; i < authPrivileges.length; i++) {
                                    if (authPrivileges[i].nm == "IM") {
                                        let imlist = authPrivileges[i].list;
                                        for (let jj = 0; jj < imlist.length; jj++) {
                                            if (imlist[jj].pc ==
                                                "wx_im_individual_mass_texting" && imlist[jj] !=
                                                null) {
                                                let klist = imlist[jj].list
                                                for (let k = 0; k < klist.length; k++) {
                                                    if (klist[k].pc == "wx_im_my_task") {
                                                        listData.push({
                                                            title: '我的任务',
                                                            url: '/router=im/individual/my_task',
                                                            class: 'chatbar'
                                                        })
                                                    }
                                                    if (klist[k].pc == "wx_im_my_mass_texting") {
                                                        listData.push({
                                                            title: '我的群发',
                                                            url: '/router=im/individual/my_mass_texting',
                                                            class: 'friendbar'
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                // if(this.listData.length == 1){
                                //     this.$router.push({path:this.listData[0].url})
                                // }
                                // next('/router=im/operation/operation_send_friends_circle');
                                next(listData[0].url)
                            }
                        },
                        //我的群发
                        {
                            path: 'my_mass_texting',
                            name: 'sendperson',
                            component: resolve => require([
                                '@/views/wechatMoments/groupSend/personSend'
                            ], resolve),
                            meta: {
                                title: '我的群发',
                                sidebarType: 1
                            },
                        },
                        {
                            path: "my_task",
                            name: "myMission",
                            component: resolve =>
                                require([
                                    "@/views/imManagement/myMission"
                                ], resolve),
                            meta: {
                                title: "我的任务",
                                sidebarType: 1
                            }
                        }

                    ]
                }

            ]
        },
        // 质检
        {
            path: '/router=im/inspection',
            component: Layout,
            children: [{
                    path: '/',
                    component: resolve => require(['@/views/inspection'], resolve),
                    children: [{
                            path: '/',
                            component: resolve => require(['@/views/inspection'],
                                resolve),
                            beforeEnter: (to, from, next) => {
                                console.log(JSON.parse(localStorage.getItem('authPrivileges')))
                                console.log(to, 'to')
                                let listData = []
                                let authPrivileges = JSON.parse(localStorage.getItem(
                                    'authPrivileges'))
                                for (let i = 0; i < authPrivileges.length; i++) {
                                    if (authPrivileges[i].nm == "IM") {
                                        let imlist = authPrivileges[i].list;
                                        for (let jj = 0; jj < imlist.length; jj++) {
                                            if (imlist[jj].pc ==
                                                "wx_im_quality_inspection" && imlist[jj] !=
                                                null) {
                                                let klist = imlist[jj].list
                                                listData.push({
                                                    title: '敏感词监控',
                                                    url: '/router=im/inspection/sensitive_monitor',
                                                    class: 'chatbar'
                                                })
                                                listData.push({
                                                    title: '我的群发',
                                                    url: '/router=im/individual/my_mass_texting',
                                                    class: 'friendbar'
                                                })
                                                // for (let k = 0; k < klist.length; k++) {
                                                //     if (klist[k].pc == "wx_im_my_task") {
                                                //         listData.push({
                                                //             title: '我的任务',
                                                //             url: '/router=im/individual/my_task',
                                                //             class: 'chatbar'
                                                //         })
                                                //     }
                                                //     if (klist[k].pc == "wx_im_my_mass_texting") {
                                                //         listData.push({
                                                //             title: '我的群发',
                                                //             url: '/router=im/individual/my_mass_texting',
                                                //             class: 'friendbar'
                                                //         })
                                                //     }
                                                // }
                                            }
                                        }
                                    }
                                }
                                // if(this.listData.length == 1){
                                //     this.$router.push({path:this.listData[0].url})
                                // }
                                // next('/router=im/operation/operation_send_friends_circle');
                                next(listData[0].url)
                            }
                        },
                        //我的群发
                        {
                            path: 'video_monitor',
                            name: 'sendperson',
                            component: resolve => require([
                                '@/views/inspection/videoMonitor'
                            ], resolve),
                            meta: {
                                title: '语音视频监控',
                                sidebarType: 1
                            },
                        },
                        {
                            path: "red_packet_monitor",
                            name: "myMission",
                            component: resolve =>
                                require([
                                    "@/views/inspection/redPacketMonitor"
                                ], resolve),
                            meta: {
                                title: "红包监控",
                                sidebarType: 1
                            }
                        }, {
                            path: "sensitive_monitor",
                            name: "sensitiveMonitor",
                            component: resolve =>
                                require([
                                    "@/views/imManagement/imSensitiveMonitor"
                                ], resolve),
                            meta: {
                                title: "敏感词监控",
                                sidebarType: 1
                            }
                        }

                    ]
                }

            ]
        },
        // 清粉
        {
            path: '/router=im/powder',
            component: Layout,
            children: [{
                    path: '/',
                    component: resolve => require(['@/views/powder'], resolve),
                    meta: {
                        title: '检测僵尸粉',
                        sidebarType: 1
                    },
                }

            ]
        },
        //聊天记录弹窗
        {
            path: '/router=im/chat_dailog',
            name: 'chat_dailog',
            component: resolve => require(['@/views/customerservice/chathistorydailog'], resolve),
            meta: {
                title: '关联聊天记录',
            }
        },
        //话术iframe
        {
            path: '/router=im/talkskill',
            name: 'talkskill',
            component: resolve => require(['@/views/customerservice/talkingskill'], resolve),
            meta: {
                title: '话术',
            }
        },
        //朋友圈iframe
        {
            path: '/router=im/wechatIframe',
            name: 'wechatIframe',
            component: resolve => require(['@/views/wechatMoments/operateManage/wechatIframe'], resolve),
            meta: {
                title: '查看朋友圈',
            }
        },
        //crm搜索聊天记录iframe
        {
            path: '/router=im/crmsearchchat',
            name: 'crmsearchchat',
            component: resolve => require(['@/views/customerservice/crmsearchchat'], resolve),
            meta: {
                title: '搜索聊天记录',
            }
        },
        //im管理
        {
            path: '/router=im/setting',
            name: 'imManagement',
            component: Layout,
            children: [{
                    path: 'safe_config',
                    name: 'imSecuritySettings',
                    component: resolve => require(['@/views/imManagement/imSecuritySettings'], resolve),
                    meta: {
                        title: '安全设置',
                        sidebarType: 2
                    }
                },
                {
                    path: 'wechat_account_manage',
                    name: 'imFriendManagement',
                    component: resolve => require(['@/views/imManagement/imFriendManagement'], resolve),
                    meta: {
                        title: '微信号管理',
                        sidebarType: 2
                    }
                },
                {
                    path: 'imfriendlist',
                    name: 'imFriendList',
                    component: resolve => require(['@/views/imManagement/imFriendList'], resolve),
                    meta: {
                        title: '微信号管理',
                        sidebarType: 2
                    }
                },
                {
                    path: 'friend_tag_manage',
                    name: 'imLabelManagement',
                    component: () => import('@/views/imManagement/imLabelManagement'),
                    meta: {
                        title: '标签管理',
                        sidebarType: 2
                    }
                },
                {
                    path: 'wechat_account_group',
                    name: 'imLabelManagement',
                    component: () => import('@/views/imManagement/weChatGroupManagement'),
                    meta: {
                        title: '微信号分组',
                        sidebarType: 2
                    }
                },
                {
                    path: "sensitive_words_config",
                    name: "imSensitiveSetting",
                    component: resolve =>
                        require([
                            "@/views/imManagement/imSensitiveSetting"
                        ], resolve),
                    meta: {
                        title: "敏感词设置",
                        sidebarType: 2
                    }
                }, {
                    path: "discourse_manage",
                    name: "imTalkSkill",
                    component: resolve =>
                        require([
                            "@/views/imManagement/imTalkSkill"
                        ], resolve),
                    meta: {
                        title: "话术库管理",
                        sidebarType: 2
                    }
                }, {
                    path: "statistical_indicators_config",
                    name: "imPointerSet",
                    component: resolve =>
                        require([
                            "@/views/imManagement/imPointerSet"
                        ], resolve),
                    meta: {
                        title: "统计指标设置",
                        sidebarType: 2
                    }
                }, {
                    path: "wechat_group",
                    name: "imPointerSet",
                    component: resolve =>
                        require([
                            "@/views/imManagement/imPointerSet"
                        ], resolve),
                    meta: {
                        title: "分组名称管理",
                        sidebarType: 2
                    }
                }
            ]
        },

        //本地开发使用，测试电话组件
        {
            path: '/call',
            name: 'call',
            component: Layout,
            children: [{
                path: '/',
                name: 'callcom',
                component: () => import("@/components/call"),
            }]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js